import React, { Component, ComponentType } from 'react';
import { Subtract } from 'utility-types';
import Snackbar from './snackbar';

export default Snackbar;

export interface SnackbarPropsMessage {
  text: React.ReactNode;
  header?: React.ReactNode;
  type?: 'error' | 'ok' | 'feedback' | string;
}
export interface SnackbarProps {
  openSnackbar: (message: SnackbarPropsMessage, mode?: string) => unknown;
}
export interface SnackbarState {
  openSnackbar: boolean;
  message?: SnackbarPropsMessage;
  mode?: string | null | undefined;
}

export const withSnackbar = <P extends SnackbarProps = SnackbarProps>(
  WrappedComponent: ComponentType<P>
) =>
  class withSnackbar extends Component<Subtract<P, SnackbarProps>, SnackbarState> {
    constructor(props: Subtract<P, SnackbarProps>) {
      super(props);
      this.openSnackbar = this.openSnackbar.bind(this);
      this.closeSnackbar = this.closeSnackbar.bind(this);
      this.state = {
        openSnackbar: false,
      };
    }

    openSnackbar(
      message: SnackbarPropsMessage,
      mode: string | null | undefined = null
    ) {
      if (typeof message.text === 'object') {
        Object.assign(message, { text: JSON.stringify(message.text) });
      }
      this.setState({
        message,
        openSnackbar: true,
        mode,
      });
    }

    closeSnackbar() {
      this.setState({
        openSnackbar: false,
      });
    }

    render() {
      const { openSnackbar, message, mode } = this.state;
      return (
        <div>
          <Snackbar
            openSnackbar={openSnackbar}
            header={message ? message.header : ''}
            message={message ? message.text : ''}
            type={message ? message.type : ''}
            closeSnackbar={this.closeSnackbar}
            mode={mode}
          />
          <WrappedComponent
            {...(this.props as P)}
            openSnackbar={this.openSnackbar}
          />
        </div>
      );
    }
  };
